module.exports = __webpack_public_path__ + "static/img/right-num-row-2.138315ac.webp";